import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Separator"
    width="2"
    height="2"
    viewBox="0 0 2 2"
    fill="none"
  >
    <circle cx="1" cy="1" r="1" fill="#B0BBC2" />
  </svg>,
  'Dot',
);
